// extracted by mini-css-extract-plugin
export default {"book":"Book_book__D9rz6","page":"Book_page__V8hxI","controls":"Book_controls__XU0Nl","pageButton":"Book_pageButton__NIO80"};